import { useEffect, useState } from "react";
import { Star, ChevronRight, Globe, MapPin, Bell, Smartphone, LifeBuoy, LogOut, ShieldCheck } from "lucide-react";
import { getPriestProfile } from "../lib/api";
import { usePriest } from "../lib/auth";

export default function PriestProfile() {
  const { logout } = usePriest();
  const [d, setD] = useState(null);
  useEffect(() => { getPriestProfile().then(setD).catch(() => {}); }, []);
  if (!d) return <p className="text-sm text-[#7A6E64]">Loading profile…</p>;
  const rows = [
    { icon: Globe, label: "Language", value: "English" },
    { icon: MapPin, label: "Service location", value: "Rajajinagar, Bengaluru" },
    { icon: Bell, label: "Notifications", value: "On" },
    { icon: Smartphone, label: "Signed-in devices", value: "View" },
    { icon: LifeBuoy, label: "Help and support", value: "" },
  ];
  return (
    <div data-testid="priest-profile" className="space-y-5">
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-[#C6603A]">Your practice</p>
        <h1 className="mt-1 font-heading text-3xl font-bold">Profile</h1>
        <p className="mt-1 text-sm text-[#7A6E64]">Manage how families discover and book your services.</p>
      </div>
      <div className="rounded-2xl border border-[#Eee3d6] bg-white p-5">
        <div className="flex items-center gap-3">
          <span className="grid h-14 w-14 place-items-center rounded-full bg-[#8B1A2B] font-heading text-xl font-bold text-white">{(d.user.name || "P")[0]}</span>
          <div><p className="font-heading text-lg font-semibold">{d.user.name}</p>
            <p className="text-sm text-[#7A6E64]">{d.user.phone || "No phone"}</p>
            <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-[#2E7D46]"><ShieldCheck size={13} /> Verified priest account</p></div>
        </div>
        <div className="mt-4 grid grid-cols-3 divide-x divide-[#F0E8DC] border-t border-[#F0E8DC] pt-4 text-center">
          <div><p className="flex items-center justify-center gap-1 font-heading text-xl font-bold"><Star size={15} className="fill-[#E8A33D] text-[#E8A33D]" />{d.stats.rating}</p><p className="text-xs text-[#8A8072]">Rating</p></div>
          <div><p className="font-heading text-xl font-bold">{d.stats.ceremonies}</p><p className="text-xs text-[#8A8072]">Ceremonies</p></div>
          <div><p className="font-heading text-xl font-bold">₹{Math.round(d.stats.earned / 1000)}K</p><p className="text-xs text-[#8A8072]">Earned</p></div>
        </div>
      </div>
      <div className="rounded-2xl border border-[#Eee3d6] bg-white p-2">
        {rows.map(({ icon: Icon, label, value }) => (
          <button key={label} className="flex w-full items-center justify-between rounded-xl px-3 py-3 text-sm hover:bg-[#F9F4EC]">
            <span className="flex items-center gap-2.5 text-[#4A4038]"><Icon size={16} className="text-[#8B1A2B]" /> {label}</span>
            <span className="flex items-center gap-1 text-[#8A8072]">{value}<ChevronRight size={15} /></span>
          </button>
        ))}
      </div>
      <button onClick={logout} data-testid="priest-profile-logout" className="flex w-full items-center justify-center gap-2 rounded-xl border border-[#E7C9CD] py-3 text-sm font-semibold text-[#8B1A2B]"><LogOut size={16} /> Log out</button>
    </div>
  );
}
